import React from 'react'
import { X } from 'lucide-react'
import { formatearFechaParaMostrar } from '../utils/dateUtils'

function ClienteDetalleModal({ cliente, onClose }) {
  if (!cliente) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl mx-2 relative animate-fade-in">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          onClick={onClose}
          aria-label="Cerrar"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="p-6 sm:p-8 overflow-y-auto max-h-[80vh]">
          <h2 className="text-xl font-bold mb-4 text-primary-700 flex items-center gap-2">
            Detalle del Cliente
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
            <div><span className="font-semibold">ID:</span> {cliente.id}</div>
            <div><span className="font-semibold">Tipo:</span> {cliente.tipo_cliente || 'NORMAL'}</div>
            <div><span className="font-semibold">Empresa:</span> {cliente.empresa}</div>
            <div><span className="font-semibold">Nombre:</span> {cliente.nombre}</div>
            <div><span className="font-semibold">Número:</span> {cliente.numero}</div>
            <div><span className="font-semibold">Estado:</span> {cliente.estado}</div>
            <div><span className="font-semibold">Placa:</span> {cliente.placa}</div>
            <div><span className="font-semibold">Desde:</span> {cliente.desde_mesanio_deuda || '-'}</div>
            {cliente.tipo_cliente === 'NORMAL' && (
              <div>
                <span className="font-semibold">Día de Cobro:</span> {cliente.dia_cobro ?? 13}
                <span className="ml-2 text-xs text-gray-500">(Día del mes para cambiar a DEUDA)</span>
              </div>
            )}
            <div><span className="font-semibold">Fecha de registro:</span> {formatearFechaParaMostrar(cliente.fecha)}</div>
            {cliente.tipo_cliente === 'PROGRAMADO' && (
              <>
                <div><span className="font-semibold">Fecha/Hora de Envío:</span> {formatearFechaParaMostrar(cliente.fecha_hora_envio)}</div>
                <div><span className="font-semibold">Repetir cada X días:</span> {cliente.repetir_cada_dias}</div>
              </>
            )}
            <div className="md:col-span-2 mt-2">
              <span className="font-semibold">Mensaje:</span>
              <div className="whitespace-pre-line break-words bg-gray-50 rounded p-3 mt-1 text-sm text-gray-800">
                {cliente.mensaje}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClienteDetalleModal 